import { useState, startTransition } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Space, Select, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { langChange } from '@/app/reducers/headerSlice';
import { useI18n } from '@/i18n';
import './index.less';

const langOptions = [{ label: '简体中文', value: 'zh' }, { label: 'English', value: 'en' }];

export default function LangSwitcher() {
  const dispatch = useDispatch();
  const { value: language, currency } = useSelector(state => state.lang);
  const $t = useI18n('component.header.language');
  const [langOpen, setLangOpen] = useState(false);
  const [LangAndCurrency, setLangAndCurrency] = useState({ language, currency });

  const onLanguageChange = (language) => {
    setLangAndCurrency(pre => ({ ...pre, language }));
  };
  const onCurrencyChange = (currency) => {
    setLangAndCurrency(pre => ({ ...pre, currency }));
  };
  const handleClickSave = () => {
    startTransition(() => {
      dispatch(langChange(LangAndCurrency));
    });
    setLangOpen(false);
  };
  const onOpenLang = (open) => {
    setLangOpen(open);
  };

  const currencyOptions = [{ label: $t('CNY-RMB'), value: 'CNY' }, { label: 'USD-US Dollar', value: 'USD' }];

  const relatedLangItems = [
    {
      key: '1',
      label: (
        <div className="lang-switcher-panel" onClick={e => e.stopPropagation()}>
          <div>{$t('Language')}</div>
          <Select value={LangAndCurrency.language} onChange={onLanguageChange} options={langOptions} />
          <div>{$t('Currency')}</div>
          <Select value={LangAndCurrency.currency} onChange={onCurrencyChange} options={currencyOptions} />
          <Button type='primary' block onClick={handleClickSave}>{$t('save')}</Button>
        </div>
      )
    }
  ];

  return (
    <Dropdown
      open={langOpen}
      onOpenChange={onOpenLang}
      trigger={['click']}
      destroyOnHidden={true}
      className='lang-switcher-dropdown'
      menu={{ items: relatedLangItems }}
    >
      <span className="lang-switcher-trigger" onClick={(e) => e.stopPropagation()}>
        <Space>{langOptions.find(item => item.value === language)?.label}-{currency}<DownOutlined /></Space>
      </span>
    </Dropdown>
  );
}